import { RestRequest, RestContext, ResponseFunction } from 'msw'
import { requireAuthenticatedUser } from '../decorators'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from './mockDataCommon'
import type { TEntityNote } from '~/types/note/models'

export function makeNoteAPIs<T extends TEntityNote>({
  apiPathEntityNamePrefix,
  getNoteListDataFn,
}: {
  apiPathEntityNamePrefix: string
  getNoteListDataFn: () => Promise<T[]>
}) {
  interface GetNotesResponse {
    data: T[]
  }

  async function getNotes(
    req: RestRequest,
    res: ResponseFunction,
    ctx: RestContext
  ) {
    const responseBody: GetNotesResponse = {
      data: await getNoteListDataFn(),
    }
    return res(ctx.status(200), ctx.json(responseBody))
  }

  // post

  const postNote = async (
    req: RestRequest,
    res: ResponseFunction,
    ctx: RestContext
  ) => {
    return addToEntityListData(req, res, ctx, getNoteListDataFn)
  }

  const patchNote = async (
    req: RestRequest,
    res: ResponseFunction,
    ctx: RestContext
  ) => {
    return updateEntityListData(req, res, ctx, getNoteListDataFn)
  }

  const deleteNote = async (
    req: RestRequest,
    res: ResponseFunction,
    ctx: RestContext
  ) => {
    return deleteEntityListData(req, res, ctx, getNoteListDataFn)
  }

  const handlers = [
    {
      method: `get`,
      path: `/api/${apiPathEntityNamePrefix}notes`,
      handler: getNotes,
    },
    {
      method: `post`,
      path: `/api/${apiPathEntityNamePrefix}notes`,
      handler: postNote,
    },
    {
      method: `patch`,
      path: `/api/${apiPathEntityNamePrefix}notes/:id`,
      handler: patchNote,
    },
    {
      method: `delete`,
      path: `/api/${apiPathEntityNamePrefix}notes/:id`,
      handler: deleteNote,
    },
  ].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))

  return { getNotes, postNote, patchNote, deleteNote, handlers }
}
